// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__dZzQK","root__banner":"style_root__banner__1BapG","root__banner--title":"style_root__banner--title__1xXuk","root__banner--des":"style_root__banner--des__3nCfx"};